export default __webpack_public_path__ + "static/media/rjlogolg.60ef1fee.png";